import * as React from 'react'
import {
  Wrapper,
  InnerWrapper,
  SpinnerSize,
  SecondaryLine,
  TernaryLine,
  PrimaryLine,
} from './Spinner.styles'

interface Props {
  size?: SpinnerSize
}

const Spinner: React.SFC<Props> = ({ size }) => (
  <div>
    <Wrapper size={size}>
      <InnerWrapper>
        <SecondaryLine />
        <TernaryLine />
        <PrimaryLine />
      </InnerWrapper>
    </Wrapper>
  </div>
)

Spinner.defaultProps = {
  size: 'm',
}

export default Spinner
